import { forwardRef } from 'react'
import { IconProps } from '../Types'
import { filterDOMProps } from '@react-aria/utils'

export const ShopifyBrand = forwardRef<SVGSVGElement, IconProps>(({ size = 35, color, ...rest }, forwardedRef) => {
  const domProps = filterDOMProps(rest, { labelable: true, propNames: new Set(['role']) })
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 35"
      fill="none"
      ref={forwardedRef}
      xmlns="http://www.w3.org/2000/svg"
      {...domProps}
    >
      <g transform="scale(1.75)">
        <path
          d="M15.6379 4.24065C15.6261 4.15269 15.551 4.10402 15.4889 4.09866C15.4269 4.09336 14.1158 3.99366 14.1158 3.99366C14.1158 3.99366 13.2053 3.06624 13.1053 2.96359C13.0053 2.861 12.81 2.8922 12.7342 2.91509C12.723 2.91847 12.5353 2.97793 12.2246 3.07654C11.9205 2.17858 11.3836 1.3534 10.4392 1.3534C10.4132 1.3534 10.3863 1.35448 10.3595 1.35605C10.0909 0.991648 9.75819 0.833333 9.47081 0.833333C7.27085 0.833333 6.21982 3.65474 5.89028 5.08848C5.03543 5.36023 4.42814 5.55343 4.35057 5.57843C3.87341 5.73198 3.85832 5.7474 3.79566 6.20867C3.74851 6.55789 2.5 16.4633 2.5 16.4633L12.2287 18.3333L17.5 17.1634C17.5 17.1634 15.6495 4.3286 15.6379 4.24065ZM11.6869 3.24714L10.8637 3.50853C10.864 3.44901 10.8643 3.39046 10.8643 3.32642C10.8643 2.76835 10.7888 2.31901 10.6677 1.9628C11.1543 2.02545 11.4783 2.59347 11.6869 3.24714ZM10.064 2.07346C10.1993 2.42124 10.2873 2.92034 10.2873 3.59383C10.2873 3.62829 10.287 3.6598 10.2867 3.69167C9.75132 3.86179 9.16958 4.04649 8.58654 4.23179C8.91391 2.93564 9.52754 2.30961 10.064 2.07346ZM9.41039 1.4387C9.50534 1.4387 9.60099 1.47177 9.69254 1.53641C8.98748 1.87677 8.23175 2.73401 7.91261 4.44589L6.56873 4.87288C6.94255 3.56715 7.83022 1.4387 9.41039 1.4387Z"
          fill="#95BF46"
        />
        <path
          d="M15.5404 4.1324C15.4816 4.12725 14.2379 4.03036 14.2379 4.03036C14.2379 4.03036 13.3741 3.12913 13.2793 3.02938C13.2438 2.99226 13.196 2.97324 13.1459 2.96504L12.4481 17.965L17.4481 16.8283C17.4481 16.8283 15.6927 4.35585 15.6817 4.27038C15.6705 4.18491 15.5993 4.13761 15.5404 4.1324Z"
          fill="#5E8E3E"
        />
        <path
          d="M10.8333 6.93651L10.1609 8.98466C10.1609 8.98466 9.57173 8.66269 8.84952 8.66269C7.79076 8.66269 7.73748 9.34302 7.73748 9.51446C7.73748 10.4499 10.1189 10.8083 10.1189 12.9994C10.1189 14.7233 9.05109 15.8333 7.6113 15.8333C5.88356 15.8333 5 14.7323 5 14.7323L5.46262 13.1672C5.46262 13.1672 6.37084 13.9656 7.13721 13.9656C7.63797 13.9656 7.84167 13.5619 7.84167 13.267C7.84167 12.0467 5.88793 11.9923 5.88793 9.98728C5.88793 8.29973 7.07087 6.66667 9.45873 6.66667C10.3788 6.66667 10.8333 6.93651 10.8333 6.93651Z"
          fill="white"
        />
      </g>
    </svg>
  )
})
